import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { NavigationHeader, rem } from 'design-system';
import AvatarFeed from 'features/feed/components/avatar-feed/AvatarFeed';
import useIsTablet from 'hooks/useIsTablet';
import { selectTabsPriority } from 'reducers/selectors/organiseTabs';
import { useAppSelector } from 'store/hooks';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { isWeb } from '../../../constants';
export const NavigationHeaderWithAvatar = React.memo(({ showTitle, ...props }) => {
    const isTablet = useIsTablet();
    const { hideTabNavigation } = useAppSelector(selectTabsPriority);
    const headerLeft = useMemo(() => 
    // On web the sidebar already shows the profile avatar
    (isTablet && !hideTabNavigation) || isWeb ? null : (<View style={styles.avatar}>
          <AvatarFeed />
        </View>), [hideTabNavigation, isTablet]);
    return (<NavigationHeader isInTab withFrame noPaddingTop leftContent={headerLeft} title={showTitle ? 'Invest' : undefined} {...props}/>);
});
NavigationHeaderWithAvatar.displayName = 'NavigationHeaderWithAvatar';
export const NavigationHeaderWithAvatarAndHelp = React.memo((props) => (<NavigationHeaderWithAvatar {...props} rightContent={<View style={styles.headerRight}>
        <HelpScreenButton />
      </View>}/>));
NavigationHeaderWithAvatarAndHelp.displayName = 'NavigationHeaderWithAvatarAndHelp';
const styles = StyleSheet.create({
    avatar: {
        position: 'absolute',
        left: rem(16),
    },
    headerRight: {
        marginRight: rem(16),
        alignItems: 'flex-end',
    },
});
